import type { SelectProps } from "@radix-ui/react-select";

import {
  SelectContent,
  SelectItem,
  Select as SelectPrimitive,
  SelectStateTrigger,
  SelectStateValue,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { Risk } from "@/utils/patient";

type Option = { label: string; value: string };

export type SelectCustomProps = SelectProps & {
  className?: string;
  options: Array<Option>;
  placeholder?: string;
  noOptionPlaceholder?: string;
  risk?: Risk | "tooth";
  disease?: string;
  isMotive?: boolean;
};

const Select = ({
  className,
  options,
  value,
  placeholder,
  noOptionPlaceholder,
  risk,
  disease,
  isMotive = false,
  disabled,
  onValueChange,
}: SelectCustomProps) => (
  <SelectPrimitive value={value} onValueChange={onValueChange}>
    {risk ? (
      <SelectStateTrigger
        className={className}
        disabled={disabled}
        risk={risk}
        disease={disease}
        value={value}
      >
        <SelectStateValue />
      </SelectStateTrigger>
    ) : (
      <SelectTrigger
        className={className}
        disabled={disabled}
        isMotive={isMotive}
      >
        <SelectValue
          placeholder={
            <span className="text-muted-foreground font-normal text-sm w-full text-left truncate">
              {placeholder}
            </span>
          }
        />
      </SelectTrigger>
    )}
    <SelectContent>
      {options.length === 0 ? (
        <p className="px-2 py-1 text-muted-foreground text-sm text-center italic">
          {noOptionPlaceholder ?? "Aucune option"}
        </p>
      ) : (
        options.map((option) => (
          <SelectItem key={option.value} value={option.value} risk={risk}>
            {option.label}
          </SelectItem>
        ))
      )}
    </SelectContent>
  </SelectPrimitive>
);

export { Select };
